module.exports = __webpack_public_path__ + "static/media/human-movement.1406376e.jpg";